<template>
  <view class="transfor-order-card">
    <view
      class="transfer-segment-card"
      wx:for="{{segmentList}}"
      wx:for-item="orderList"
      wx:if="{{orderList}}"
      wx:key="index"
    >
      <view class="content">
        <view class="content-header">
          <image
            class="content-header-icon"
            src="https://ut-static.udache.com/webx/sfc/E-gDDXz0ky_iMRsP5PAOK.png"
          />
          <text class="content-header-text">第{{ index + 1 }}程</text>
        </view>
        <order-info-list isTransfer bind:click="showSSI" orderList="{{orderList}}" isChange="{{getIsChange(orderList)}}" />
      </view>
      <view class="tip" wx:if="{{index !== segmentList.length -1}}">
        <image
          class="tip-icon"
          src="https://ut-static.udache.com/webx/sfc/f7hhMa7YrgQP9UnbmT__E.png"
        />
        <transfer-info-tip 
          style="flex: 1" 
          noIcon
          orderId="{{baseInfo.order_id}}"
          startStation="{{segmentList[index][0]?.to_station_name ?? ''}}"
          toStation="{{segmentList[index+1][0]?.from_station_name ?? ''}}"
          stopTime="{{stopTime}}"
        />
      </view>
      <view class="line" wx:if="{{index !== segmentList.length -1}}"></view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import store from '@/store'

createComponent({
  props: {
    orderList: {
      type: Array,
      value: () => []
    }
  },
  computed: {
    ...store.mapState({
      baseInfo: 'order.base_info'
    }),
    segmentList() {
      const _segmentList = []
      // this.orderList?.forEach((order) => {
      //   order.tickets_info?.forEach((ticket) => {
      //     const index = ticket.union_segment_index - 1
      //     if (!_segmentList[index]) {
      //       _segmentList[index] = []
      //     }
      //     const targetOrder = _segmentList[index]?.find((item) => item.order_id === order.order_id)
      //     if (targetOrder) {
      //       targetOrder?.tickets_info?.push(ticket)
      //     } else {
      //       const { from_station_name, to_station_name, start_time, arrive_time } = ticket
      //       const newOrder = {
      //         ...order,
      //         from_station_name,
      //         to_station_name,
      //         start_time,
      //         arrive_time,
      //         tickets_info: [ticket]
      //       }
      //       _segmentList[index].push(newOrder)
      //       console.log('%c [ _segmentList ]-68', 'font-size:13px; background:pink; color:#bf2c9f;', _segmentList)
      //     }
      //   })
      // })
      this.orderList?.forEach((order) => {
        if(!order || !order.tickets_info) return 
        const ticket = order.tickets_info[0]
        const index = ticket.union_segment_index - 1
        if (!_segmentList[index]) {
          _segmentList[index] = []
        }
        _segmentList[index].push(order)
      })
      return _segmentList
    },
    stopTime() {
      if(!this.baseInfo?.extension) return ''
      const extension = JSON.parse(this.baseInfo.extension) ?? {}
      return extension?.transfer_stop_time ?? ''
    }
  },
  methods: {
    getIsChange(arr) {
      return arr.some((order) => order.is_change)
    },
    showSSI(e) {
      this.triggerEvent('showSSI',e?.detail ?? {})
    }
  }
})
</script>

<style scoped lang="stylus">
.transfor-order-card
  display flex
  flex-direction column
  background #fff
  margin 0 -12px 10px
  padding 7px 10px 0 30px
  .transfer-segment-card
    display flex
    flex-direction column
    position relative
    .content
      position relative
      z-index 2
      display flex
      flex-direction column
      &-header
        display flex
        align-items center
        margin-left -25px
        margin-bottom 10px
        &-icon
          height 20px
          width 20px
          margin-right 5px
        &-text
          font-family PingFangSC-Medium
          font-size 18px
          font-weight 500
          line-height 18px
          letter-spacing 0.08em
          color #222
    .tip
      display flex
      align-items center
      margin-left -23.5px
      position relative
      z-index 2
      padding-bottom 11px
      &-icon
        height 17.5px
        width 17.5px
        margin-right 6px
    .line
      position absolute
      top 0
      left -15.5px
      height 100%
      width 0
      border-right 1px dashed #CCCCCC
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    'transfer-info-tip': '@/components/transfer-info-tip',
    'order-info-list': '@/components/order-info-list'
  }
}
</script>